import { ChangeEvent, useState } from 'react';
import { NavLink, useNavigate } from 'react-router';

const BackofficeBriefsMarketMenu = () => {


  const [leadId, setLeadId] = useState<string>("");
  const navigate = useNavigate();

  function updateLeadId(event: ChangeEvent<HTMLInputElement>): void {
    setLeadId(event.target.value);
  }

  function handleKeyDown(event: React.KeyboardEvent<HTMLInputElement>): void {
    if (event.key === "Enter") {
     searchLead();
    }
  }

  function searchLead(): void {
    navigate(`/backoffice/leads/all/${leadId}`);
  }


  return (
    <ul className="nav nav-underline backoffice-briefs-menu" style={{marginBottom: 20}}>
      <li className="nav-item" role="presentation">
        <NavLink to="/backoffice/leads/all" className="nav-link" id="all_briefs_tab"  type="button"  aria-controls="all_briefs" >
          Tous les briefs
        </NavLink>
      </li>
      <li className="nav-item" role="presentation">
        <NavLink to="/backoffice/leads/to-validate" className="nav-link" id="briefs_validation_tab"  type="button"  aria-controls="all_briefs" >
          Briefs à valider
        </NavLink>
      </li>
      <li className="nav-item" role="presentation">
        <NavLink to="/backoffice/leads/bills-to-validate" className="nav-link bo-bills-to-validate-link" id="briefs_sended_tab"  type="button"  aria-controls="briefs_sended" >
          Factures à valider
        </NavLink>
      </li>
      <li>
        <input type="text" className="form-control" id="search_brief" placeholder="Rechercher un brief"  onChange={updateLeadId} onKeyDown={handleKeyDown}/>
      </li>
    </ul>
  );

}

export default BackofficeBriefsMarketMenu;
